import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import { FilterMatchMode } from "primereact/api";
// import { InputText } from "primereact/inputtext";
// import { Button } from "primereact/button";
// import ButtonFeature from "../../features/Button.jsx";
import "primeicons/primeicons.css";
import { MdOutlineDelete } from "react-icons/md";
import { TabView, TabPanel } from "primereact/tabview";
import instance from "../../api/api.js";
// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";

import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";

import { styleIcone } from "../../shared";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
import { IoPersonOutline } from "react-icons/io5";

function RoleList() {
  // const MySwal = withReactContent(Swal);

  const [roles, setRoles] = useState([]);
  // const [roleId, setRoleId] = useState("");
  // const [status, setStatus] = useState("");

  // const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // const action = ({ id, status }) => {
  //   const modifyRole = () => {
  //     setRoleId(id);
  //     console.log(roleId);
  //     setStatus(status);
  //     setShowModal(true);
  //   };
  //   return( <button className="btn bg-danger text-light fw-bold" onClick={modifyRole}>
  //     <AiFillDelete /> Supprimer
  //   </button>)

  // };

  const getListOfRole = async () => {
    try {
      const response = await instance.get("roles");
      console.log("getListOfRole", response.data);
      console.log("getListOfRole", response.data.data);
      setRoles(response.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    libelle: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  useEffect(() => {
    getListOfRole();
  }, []);

  // const modifyRoles = async (e) => {
  //   e.preventDefault();
  //   setIsLoading(true);
  //   try {
  //     const response = await instance.put(`roles/${roleId}`, {
  //       status: status === "Actif" ? "Expiré" : "",
  //     });
  //     console.log("RESPONSE", response);

  //     if (response.data.status === false) {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setIsLoading(false);
  //     } else {
  //       MySwal.fire({
  //         title: response.data.message,
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //       setRoleId("");
  //       setShowModal(false);
  //       setIsLoading(false);
  //       // getListOfRole();
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     MySwal.fire({
  //       title: error.data.message,
  //       icon: "info",
  //       showConfirmButton: true,
  //     });
  //   }
  // };

  return (
    // <div className="conteneur-page">
    //   {showModal ? (
    //     <div className="conteneur-modal">
    //       <form onSubmit={modifyRoles}>
    //         <h5 className="m-2">Voulez-vous supprimer ce role ?</h5>
    //         <ButtonFeature
    //           titre="Confirmer"
    //           styleBtn={styleBtn}
    //           isLoading={isLoading}
    //         />
    //         <button
    //           className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
    //           onClick={(e) => {
    //             e.preventDefault();
    //             setShowModal(false);
    //           }}
    //         >
    //           Annuler
    //         </button>
    //       </form>
    //     </div>
    //   ) : null}
    //   <h1>Liste des roles</h1>
    //   {isLoading ? (
    //     <h1 className="text-center mt-5">Chargement....</h1>
    //   ) : (

    //   )}
    // </div>

    <AllCompomentShared
      libelleHeaderComp={"Liste des roles"}
      titleStatisticHeaderComp={"Nombre de roles"}
      nbreTotalStatistiqueComp={roles.length}
      SearchTableIsSearch={true}
      placeholderInputSearch={"Recherche"}
      globalFilterValue={globalFilterValue}
      onGlobalFilterChange={onGlobalFilterChange}
      iconeStatistiqueHeader={<IoPersonOutline fontSize={"2em"} />}
      isLoading={isLoading}>
      <CouponsDatatable items={roles} filters={filters} />
    </AllCompomentShared>
  );
}
export function CouponsDatatable({ items, filters }) {
  const dt = useRef(null);
  const [open, setOpen] = useState(false);
  const options = [
    {
      name: "Supprimer",
      icone: <MdOutlineDelete style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
      methode: (idData) => {
        isDeleteUser(idData);
      },
    },
  ];
  const isDeleteUser = (id) => {
    console.log(id);
    setOpen(true);
  };
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  return (
    <div>
      <ModalDelete
        modalTitle={"Voulez-vous vraiment supprimer cet role ?"}
        setOpenMethod={setOpen}
        openProp={open}
        dataInfoForBtn={[
          {
            libelleBtn: "Oui",
            color: "error",
            methode: () => {
              console.log("dff");
              // if(isRejectedBtn){
              //   changeStatut('refuse',valueTextField)
              // }
              // if(!isRejectedBtn){
              //   changeStatut('accepter')
              // }
            },
          },
          {
            libelleBtn: "Non",
            isStyle: true,
            methode: () => {
              console.log("dff");
              // dispatch(showModal())
            },
          },
        ]}
      />
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={["libelle"]}>
            <Column
              field="libelle"
              style={{ textAlign: "center" }}
              header="Libelle"></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default RoleList;
